class GroupSessionRequest {
  static create = {
    groupSessionTopic: null,
    groupSessionDescription: null,
    groupSessionProfessionalId: null,
    groupSessionStartTime: null,
    groupSessionEndTime: null,
    groupSessionAmount: null,
    groupSessionImage: null,
    groupSessionRequirements: null,
    groupSessionMaxAttendance: null
  };
  static enroll = {
    groupSessionId: null,
    customerId: null
  };
  static readByCustomerId = {
    groupSessionCustomerId: null
  };
  static readByProfessionalId = {
    groupSessionProfessionalId: null
  };
  static readByGroupSessionId = {
    groupSessionId: null
  };
  static readEnrolledClassCustomers = {
    groupSessionId: null
  };
  static readAllGroupSessions = {
    page: 1
  };
  static readUserGroupSessions = {};
}

export default GroupSessionRequest;
